/**
 * Hotels-only Hubwayz draft (no LDS flight) — used by passengers Continue gate.
 */
export function isHubwayzHotelsOnlyDraft(bookingDraft) {
  if (!bookingDraft || typeof bookingDraft !== "object") return false;
  if (bookingDraft.hotelsOnly === true) return true;
  return (
    !!bookingDraft.hubwayzOfferCode &&
    !bookingDraft.rawDeal &&
    !bookingDraft.flightId
  );
}
